import QaCreate from './qa-create';

export default class DmCreate extends QaCreate
{
    constructor(questionTypeValueToId)
    {
        // call QaCreate constructor
        super(questionTypeValueToId);
    }

    /**
     * addDeleteOptionToRadioCheck 
     *
     * Digital Maturity doesn't allow you to change/edit/delet the responses
     * 
     * @return null
     */
    addDeleteOptionToRadioCheck()
    {
        return;
    }
}
